module.exports = __webpack_public_path__ + "img/BigLogo@2x.d1cce6d7.jpg";